module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2r7n4r-2d25162e14dc4d58e30b5bda4f5e8e13.svg";